import academic from './Academics'
import docs from './Docs'
import juridics from './Juridics'
import laborData from './LaborData'

export const Academics = academic
export const Docs = docs
export const Juridics = juridics
export const LaborData = laborData
